import React from 'react';
// import DashboardLayout from '../components/Layouts/DashboardLayout';
import DashboardSidebar from '../components/DashboardComponents/DashboardSidebar';
import InnerBanner from '../components/PagesComponents/InnerBanner';
import SellerEnquiryInfoList from '../components/DashboardComponents/SellerEnquiryInfoList';
const SellerEnquiry = () => {
 return (
    <>
{/* <InnerBanner pageKey="buyerDashboard" /> */}

      <section className='dashboard'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-12'>
                   <SellerEnquiryInfoList/> 
                </div>
               
            </div>
        </div>
      </section>
    </>
 );

};

export default SellerEnquiry;